import memoize from 'lodash/memoize';
import header_dashboard from './header_dashboard.png';
import header_arrival from './header_arrival.png';
import header_departures from './header_departures.png';
import header_entertainment from './header_entertainment.jpg';
import header_house_rules from './header_house_rules.jpg';
import header_house_manual from './header_house_manual.png';
import home_icon from './home_icon.png';
import map_icon from './map_icon.png';
import message_icon from './message_icon.png';
import login_background from './login_background.png';
import operto_logo_white from './operto_logo_white.png';

const images = {
  header_dashboard,
  header_arrival,
  header_departures,
  header_entertainment,
  header_house_rules,
  header_house_manual,
  home_icon,
  map_icon,
  message_icon,
  login_background,
  operto_logo_white,
};

const memoizeImage = memoize(
  (key: string) => images[key as keyof typeof images] ?? key,
);

export default (key: string) => memoizeImage(key);
